/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import VariantSelector from './VariantSelector';
import { Link } from 'preact-router/match';
import { Waypoint } from 'react-waypoint';
import { route } from 'preact-router'

import {PhotoSwipe} from 'react-photoswipe';
import 'react-photoswipe/lib/photoswipe.css';
import Swiper from 'react-id-swiper';
import 'react-id-swiper/src/styles/css/swiper.css';

import {
  colabId,
  acneId
} from '../../../components/app.js'

const isGeoProduct = id => (id === colabId || id === acneId)

class Product extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false
		};

		this.handleOptionChange = this.handleOptionChange.bind(this);
		this.handleQuantityChange = this.handleQuantityChange.bind(this);
		this.findImage = this.findImage.bind(this);
	}

	componentWillMount() {
		const availableVariants = this.props.product.variants.edges.filter(c => c.node.availableForSale)
		const firstAvailable = availableVariants[0]
		
		if (firstAvailable) {
			this.setState({selectedVariant: firstAvailable.node})
		}
		this.props.product.options.forEach((selector) => {
			this.setState({
				selectedOptions: { [selector.name]: firstAvailable
					? selector.values.find(value => firstAvailable.node.title === value)
					: selector.values[0]
				}
			});
		});
	}

	findImage(images, variantId) {
		const primary = images[0];

		const image = images.filter((image) => {
			return image.variant_ids.includes(variantId);
		})[0];

		return (image || primary).src;
	}

	handleOptionChange(event) {
		const target = event.target;
		let selectedOptions = this.state.selectedOptions;
		selectedOptions[target.name] = target.value;

		const selectedVariant = this.props.product.variants.edges.find((variant) => variant.node.selectedOptions.every((selectedOption) => {
			return selectedOptions[selectedOption.name] === selectedOption.value;
		})).node;

		this.setState({
			selectedVariant,
			selectedVariantImage: selectedVariant.image.src
		});
	}

	handleQuantityChange(event) {
		this.setState({
			selectedVariantQuantity: event.target.value
		});
	}

	render() {
		let variantImage = this.state.selectedVariantImage || this.props.product.images.edges[0].node.src;
		const availableVariants = this.props.product.variants.edges.filter(c => c.node.availableForSale)
		
		const firstAvailable = availableVariants[0]
		let variant = this.state.selectedVariant || firstAvailable && firstAvailable.node || {};
		let variantQuantity = this.state.selectedVariantQuantity || 1;

		let variant_selectors = this.props.product.options.map((option) => (
			<VariantSelector
				handleOptionChange={this.handleOptionChange}
				key={option.id.toString()}
				option={option}
				selected={variant.title}
				available={this.props.product.variants.edges}
				availableVariants={availableVariants.map(c => c.node.title)}
			/>
		));

		// we are on a single product page
		if (this.props.path === "/item/:handle") {
			const { isLast } = this.props
			const params = {
				
				pagination: {
				  el: '.swiper-pagination',
				  type: 'bullets',
				  clickable: true
				},
				navigation: {
				  nextEl: '.swiper-button-next',
				  prevEl: '.swiper-button-prev'
				},
				spaceBetween: 30
			  }
			return (
				<div className="ProductPage">
					<PhotoSwipe
						isOpen={this.state.isOpen}
						items={this.props.product.images.edges.map(c => ({src: c.node.zoom, w: 1200,
							h: 1200,}))}
						options={{
							history:false,
							zoomEl: false,
							maxSpreadZoom: 1,
							closeOnScroll: false,
							getDoubleTapZoom: function(isMouseClick, item) {
							  return item.initialZoomLevel;
							},
							pinchToClose: false
						}}
						onClose={() => this.setState({isOpen: false})}
					/>
					<div class="col-6 left">
						<Swiper {...params}>
							{this.props.product.images.edges.map((c, key) =>
								<img onClick={e => this.setState({isOpen: true})} key={key} src={ c.node.gallery} alt={`${this.props.product.title} product shot`} />
							)}
						</Swiper>
					</div>

					<div class="col-6  left">
					<div class="deets">
					<h5 className="Product__title">{this.props.product.title}</h5>
					{variant && <span className="Product__price">${variant.price}</span>}
				

					{this.props.product.variants.edges.length > 1 && variant_selectors}
					<label className="Product__option">
						
						<input min="1" type="number" defaultValue={variantQuantity} onChange={this.handleQuantityChange} />
					</label>
					<button className="Product__buy button" disabled={!variant || !variant.availableForSale} onClick={() => this.props.addVariantToCart(availableVariants.length > 1 ? variant.id : availableVariants[0].node.id, variantQuantity)}>Add to Cart</button>
					
				<p class="desc">
					<div dangerouslySetInnerHTML={{__html: this.props.product.descriptionHtml}} />
					</p>
					</div>
					</div>
					<Waypoint onEnter={() => {
						!window.location.href.includes(this.props.product.handle)  && window.history.pushState({}, this.props.product.title,  '/item/' + this.props.product.handle)
					}} key={this.props.product.id}/>

					{isLast && <Waypoint onEnter={this.props.onEnter} key={this.props.product.id}/>}
					<div class="clearfix"></div>
				</div>
			)
		}

		return (
			<div className={`Product ${!this.props.product.availableForSale ? ' soldout' : ''} ${availableVariants.length === 1 ? ' novariant' : ''}`}>
        <Link href={"/item/" + this.props.product.handle}>
          {this.props.product.images.edges.length ? <img src={variantImage} alt={`${this.props.product.title} product shot`} /> : null}
          <h5 className="Product__title">{this.props.product.title}</h5>
        </Link>
				
				{variant && <span className="Product__price">${variant.price}</span>}
				{this.props.product.variants.edges.length > 1 && variant_selectors}
				<label className="Product__option">
          
					<input min="1" type="number" defaultValue={variantQuantity} onChange={this.handleQuantityChange} />
				</label>
				{isGeoProduct(this.props.product.id)
					?	<Link href={"/item/" + this.props.product.handle}><button className="button">available in specific locations</button></Link>
					: <button
							className="Product__buy button"
							disabled={!variant || !variant.availableForSale}
							onClick={() => this.props.addVariantToCart(availableVariants.length > 1 ? variant.id : availableVariants[0].node.id, variantQuantity)}
						>Add to Cart</button>
				}
				
			</div>
		);
	}
}

export default Product;



// WEBPACK FOOTER //
// ./routes/shop/components/Product.js